import { Record } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { record_type, lambda_type, unit_type, string_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import { createElement } from "react";
import react_simple_code_editor from "react-simple-code-editor";
import { highlightSqlCode } from "../../../src/Components/Highlight/Highlight.js";
import "../../../src/Components/Highlight/ssms.css";

function Editor(props) {
    return null;
}

export class SQLEditorProps extends Record {
    constructor(Value, OnValueChange, Id) {
        super();
        this.Value = Value;
        this.OnValueChange = OnValueChange;
        this.Id = Id;
    }
}

export function SQLEditorProps$reflection() {
    return record_type("Components.SimpleCodeEditor.SQLEditorProps", [], SQLEditorProps, () => [["Value", string_type], ["OnValueChange", lambda_type(string_type, unit_type)], ["Id", string_type]]);
}

export function sqlEditor(props) {
    return createElement(react_simple_code_editor, {
        highlight: highlightSqlCode,
        onValueChange: props.OnValueChange,
        padding: 10,
        textareaId: props.Id,
        value: props.Value,
    });
}

